import React, { Fragment } from "react";

const Partner = () => {
  return (
    <Fragment>
      <section className="top-heading-pt">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div
                className="section-title-ca wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <h1>TapTap Partner Program</h1>
                <p className="sa-par">
                  Looking for a delivery partner? Choose Shiprocket and unlock
                  the value of your business.
                </p>
                <a href="#" className="btn get-started-top btn-ps">
                  Learn More
                </a>
              </div>
            </div>

            <div className="col-md-6">
              <div className="pt-secimg">
                <img src="img/2354111.png"></img>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sa-second">
        <div className="container">
          <div className="section-title wow bounceInLeft" data-wow-delay="0.2s">
            <h2>Choose a partnership that meets your goals</h2>
          </div>
          <div className="row">
            <div className="col-md-4 wow fadeInUp" data-wow-delay="1s">
              <div className="pt-card">
                <div className="pt-card-img">
                  <img src="https://img.icons8.com/nolan/80/api-settings.png" />
                </div>
                <h5>Platform Partners</h5>
                <p>
                  The TapTap APIs envisage a community of developers along with
                  a learning platform for tech enthusiasts. Our powerful new
                  APIs are for developers, tech enthusiasts who are determined
                  to create a seamless shipping workflow for their platforms.
                </p>
                <a href="#" className="btn get-started btn-ps">
                  Learn more
                </a>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp" data-wow-delay="1.5s">
              <div className="pt-card">
                <div className="pt-card-img">
                  <img src="https://img.icons8.com/nolan/80/console.png" />
                </div>
                <h5>Channel Partners</h5>
                <p>
                  The TapTap APIs envisage a community of developers along with
                  a learning platform for tech enthusiasts. Our powerful new
                  APIs are for developers, tech enthusiasts who are determined
                  to create a seamless shipping workflow for their platforms.
                </p>
                <a href="#" className="btn get-started btn-ps">
                  Learn more
                </a>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp" data-wow-delay="2s">
              <div className="pt-card">
                <div className="pt-card-img">
                  <img src="https://img.icons8.com/nolan/80/module.png" />
                </div>
                <h5>Service Partners</h5>
                <p>
                  The TapTap APIs envisage a community of developers along with
                  a learning platform for tech enthusiasts. Our powerful new
                  APIs are for developers, tech enthusiasts who are determined
                  to create a seamless shipping workflow for their platforms.
                </p>
                <a href="#" className="btn get-started btn-ps">
                  Learn more
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row">
            <div
              className="section-title wow bounceInRight"
              data-wow-delay="0.2s"
            >
              <h2>Additional Benefits</h2>
            </div>
            <div className="col-md-3 wow fadeInUp" data-wow-delay="1s">
              <div className="pt-sec">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/in-transit.png" />
                </div>
                <h6>Regular Trips</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-3 wow fadeInDown" data-wow-delay="1.3s">
              <div className="pt-sec">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/expensive.png" />
                </div>
                <h6>Better Earning</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-3 wow fadeInUp" data-wow-delay="1.6s">
              <div className="pt-sec">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/bank-cards.png" />
                </div>
                <h6>On-Time Pay-ment</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-3 wow fadeInDown" data-wow-delay="1.9s">
              <div className="pt-sec">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/discount.png" />
                </div>
                <h6>Exclusive Deals</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-main-third">
        <div className="container">
          <div className="row">
            <div
              className="section-title wow bounceInLeft"
              data-wow-delay="0.2s"
            >
              <h2>Why Partner with TapTap?</h2>
            </div>
            <div className="col-md-6 wow fadeInLeft" data-wow-delay="1s">
              <div className="pt-third">
                <div className="pt-third-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/in-transit.png" />
                </div>
                <h6>Regular Trips</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-6 wow fadeInRight" data-wow-delay="1.5s">
              <div className="pt-third">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/expensive.png" />
                </div>
                <h6>Better Earning</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-6 wow fadeInLeft" data-wow-delay="2s">
              <div className="pt-third">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/bank-cards.png" />
                </div>
                <h6>On-Time Pay-ment</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>

            <div className="col-md-6 wow fadeInRight" data-wow-delay="2.5s">
              <div className="pt-third">
                <div className="pt-img">
                  <img src="https://img.icons8.com/cute-clipart/80/000000/discount.png" />
                </div>
                <h6>Exclusive Deals</h6>
                <p>
                  With our growing presence across multiple cities, we always
                  have our hands full! This means you will never run out of
                  trips.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="carousel" className="testimonials">
        <div className="section-title wow bounceInRight" data-wow-delay="0.2s">
          <h2>Testimonials</h2>
        </div>
        <div className="container">
          <div className="row">
            <div
              className="col-md-8 col-md-offset-2 wow fadeInUp"
              data-wow-delay="1.5s"
            >
              <div className="quote">
                <i className="fa fa-quote-left fa-4x"></i>
              </div>
              <div
                className="carousel slide"
                id="fade-quote-carousel"
                data-ride="carousel"
                data-interval="3000"
              >
                {/* <!-- Carousel indicators --> */}
                <ol className="carousel-indicators">
                  <li data-target="#fade-quote-carousel" data-slide-to="0"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="1"></li>
                  <li
                    data-target="#fade-quote-carousel"
                    data-slide-to="2"
                    className="active"
                  ></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="3"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="4"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="5"></li>
                </ol>
                {/* <!-- Carousel items --> */}
                <div className="carousel-inner">
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/1.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                      <h6></h6>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/2.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                      <h6></h6>
                    </blockquote>
                  </div>
                  <div className="active item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/3.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/4.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/5.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/6.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className=" br-text">
        <h3>Trusted By Thousands of Online Sellers</h3>
        <p>An all-in-one eCommerce Solution for your shipping needs</p>
        <a href="#" className="btn get-started btn-ps">
          SIGNUP NOW
        </a>
      </div>
    </Fragment>
  );
};

export default Partner;
